import { combineReducers } from "redux"
import unread from "./unread"
import all from "./all"

export default combineReducers({
  unread,
  all
})
